import { Charge } from '@willow/graphql-iso/src/app';

import { isAdvance } from './charges';

export const getBalancesDueOnInactiveLoan = (
  outstandingBalance: number,
  escrowed: boolean,
  balances: { escrowBalance: number },
  charges: Charge[],
): {
  unpaidPrincipalBalance: number;
  escrowAdvance?: number;
  unpaidAdvance: number;
} => ({
  unpaidPrincipalBalance: outstandingBalance,
  escrowAdvance: escrowed ? (balances.escrowBalance < 0 ? Math.abs(balances.escrowBalance) : 0) : undefined,
  unpaidAdvance: charges.reduce((acc: number, c) => {
    if (c.status === 'CHARGED' && isAdvance(c)) {
      const amountRemaining = c.amountRemaining - c.advanceInterest;
      return acc + Math.max(amountRemaining, 0);
    }
    return acc;
  }, 0),
});
